function decimalPlaces(num) {
  var result = 0;
  var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (match) {
    result = Math.max(
      0,
      // Number of digits right of decimal point.
      (match[1] ? match[1].length : 0) -
        // Adjust for scientific notation.
        (match[2] ? +match[2] : 0)
    );
  }
  return result;
}

function getParameterByName(name, url) {
  if (!url) url = window.location.href;

  name = name.replace(/[[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);

  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function isInViewport(elem) {
  var distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

function gtagBaseShapesMapper(baseShapes) {
  return baseShapes
    .map((x) => ({
      item_id: x.baseShape,
      item_name: x.baseShape
    }))
    .flat();
}

function gtagBaseShapesProductsMapper(baseShapes) {
  return baseShapes.map((x) => gtagProductsMapper(x)).flat();
}

function gtagProductsMapper({ baseShape, products }, quantity = undefined) {
  return products.map((x) => ({
    item_id: x.productCode,
    item_name: baseShape,
    item_variant: x.longDescription,
    price: (x.priceEach ?? 0).toFixed(2),
    quantity: quantity || x.quantity
  }));
}

function gtagSparePartsMapper({ product, spareParts }, quantity = undefined) {
  return spareParts.map((x) => ({
    item_id: x.productCode,
    item_name: product.productDescription,
    item_variant: x.longDescription,
    price: (x.priceEach ?? 0).toFixed(2),
    quantity: quantity || x.quantity
  }));
}

export {
  decimalPlaces,
  getParameterByName,
  isInViewport,
  gtagBaseShapesMapper,
  gtagBaseShapesProductsMapper,
  gtagProductsMapper,
  gtagSparePartsMapper
};
